import { Component } from "react";

export class AppErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("DIR Nation render failure", error, info); }
  recover = () => {
    try {
      Object.keys(localStorage).filter((key) => /^sb-.*-auth-token$/.test(key) || key === "dir_token").forEach((key) => localStorage.removeItem(key));
    } catch {}
    window.location.reload();
  };
  render() {
    if (!this.state.error) return this.props.children;
    return <main className="flex min-h-screen items-center justify-center bg-dir-bg px-4 text-center"><div className="max-w-lg rounded-2xl border border-dir-gold/20 bg-dir-card p-8"><img src="/assets/dirnation-logo.png" alt="DIR Nation" className="mx-auto h-20 w-auto"/><h1 className="mt-6 font-display text-2xl font-bold text-dir-text">DIR Nation is restoring this page</h1><p className="mt-3 text-sm leading-6 text-dir-muted">A saved browser session or optional page feature could not be loaded. Refresh safely to continue.</p><button onClick={this.recover} className="mt-6 min-h-11 rounded-full bg-dir-gold px-6 py-3 font-bold text-dir-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-dir-gold">Refresh DIR Nation</button></div></main>;
  }
}

export class FeatureErrorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error, info) {
    const diagnostics = typeof window === "undefined" ? {} : {
      error,
      feature: this.props.name || "Optional feature",
      width: window.innerWidth,
      height: window.innerHeight,
      dpr: window.devicePixelRatio,
      userAgent: navigator.userAgent,
      componentStack: info?.componentStack,
    };
    console.error("[DIR Globe Desktop Failure]", diagnostics);
  }
  render() { return this.state.failed ? (this.props.fallback || null) : this.props.children; }
}
